export const mainUrl =
	process.env.NODE_ENV === "production" && !window.location.hostname.includes("test")
		? process.env.API_URL || "https://app.hotmaps.pro/api"
		: "https://staging.geojet.io/api";

export const api = {
	test: `${mainUrl}/test`,
	getLocationData: (hash: string) => `${mainUrl}/qr/decode-hash/${hash}`,
	getCollectionData: (hash: string) => `${mainUrl}/qr/decode-set-hash/${hash}`,
	createTransition: `${mainUrl}/qr/review`,
	createReview: `${mainUrl}/qr/review`,
	editReview: `${mainUrl}/qr/review`,
	createGeoServiceTransition: `${mainUrl}/qr/review`,
};
